module.exports = __webpack_public_path__ + "img/jjcy_logo.ea499728.jpg";